import Types from './Types';

const INITIAL_STATE = {
    teachers: [],
    teacher: {},
    isLoading: false,
    count: ''
};

export default function teachers(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_TEACHERS_SUCCESS: {
            return {
                ...state,
                teachers: payload.data,
                count: payload.data.length
            };
        }

        case Types.GET_TEACHER_SUCCESS: {
            return {
                ...state,
                teacher: payload
            };
        }

        case Types.EDIT_TEACHER_SUCCESS: {
            let data = payload.data;
            const teachers = state.teachers;
            let idx = 0;
            teachers.forEach((table, index) => {
                if (table.id === data.id) {
                    idx = index;
                    return;
                }
            });

            teachers[idx] = data;
            return {
                ...state,
                teachers: teachers
            };
        }

        // create
        case Types.CREATE_TEACHER_SUCCESS: {
            const data = payload.data.data;
            let newArray = state.teachers.slice();
            let index = state.teachers.length + 1;
            newArray.splice(index, 0, data);
            return {
                ...state,
                teachers: newArray
            };
        }
        case Types.ADD_TEACHERS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.DELETE_TEACHER_SUCCESS: {
            const newteachers = state.teachers.filter((item) => item.id !== payload);
            return {
                ...state,
                teachers: newteachers
            };
        }

        case Types.CREATE_ADMIN_SUBJECT_SUCCESS: {
            return {
                ...state,
            };
        }
        default: {
            return state;
        }
    }
}
